import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import dashboardServices from 'src/services/apiServices/dashboard-services/dashboard-services';

const {
  GET_DASHBOARD_PTO_UPDATE_FAILURE,
  GET_DASHBOARD_PTO_UPDATE_REQUEST,
  GET_DASHBOARD_PTO_UPDATE_LOADER,
  GET_DASHBOARD_PTO_UPDATE_SUCCESS,
} = DashboardConstants;

function* dashboardPtoUpdated(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_DASHBOARD_PTO_UPDATE_LOADER });
    const response = yield call(dashboardServices.getLatestPtoUpdate, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_DASHBOARD_PTO_UPDATE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_DASHBOARD_PTO_UPDATE_FAILURE, payload: error });
  }
}

function* dashboardPtoUpdatedSaga() {
  yield takeEvery(GET_DASHBOARD_PTO_UPDATE_REQUEST, dashboardPtoUpdated);
}

export default dashboardPtoUpdatedSaga;
